<template>
  <div v-if="selectedPolicy && isOpen">
    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="vuemodal">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Cancellation Policy ({{ selectedPolicy.policyTitle }})</h4>
                <h6>
                  Last Updated: {{ model.modifiedDate ? model.modifiedDate.stringFullDate : '-' }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="row">
                      <!-- Start: Form -->
                      <div class="col-sm-3 divider-right pr-25">
                        <div class="form-group">
                          <label class="required">Time Before Trip (hour)</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.totalHourBeforePickup.$error,
                            }"
                            type="number"
                            v-model="model.totalHourBeforePickup"
                          />
                          <div
                            v-if="isSubmitted && $v.model.totalHourBeforePickup.$error"
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.totalHourBeforePickup.required"
                              >Rate is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.totalHourBeforePickup.minValue"
                              >Min hour is
                              {{
                                $v.model.totalHourBeforePickup.$params.minValue.min
                              }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">
                            Charge Amount <span class="--grey50">(%)</span>
                          </label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.percentageCharge.$error,
                            }"
                            type="number"
                            v-model="model.percentageCharge"
                            placeholder="Number"
                            step="any"
                          />
                          <div v-if="isSubmitted && $v.model.percentageCharge.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.percentageCharge.required"
                              >Rate is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.percentageCharge.minValue"
                              >Min percentage is
                              {{ $v.model.percentageCharge.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                        <div
                          class="modal-footer"
                          v-if="isAllowToCreate || isAllowToUpdate"
                        >
                          <button
                            type="button"
                            class="btn btn-default"
                            @click.prevent="reset()"
                          >
                            Reset
                          </button>
                          <button
                            v-if="!isUpdate && isAllowToCreate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate && isAllowToUpdate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                      <!-- End: Form -->
                      <!-- Start: Table -->
                      <div class="col-sm-9 divider-left pl-20">
                        <div class="table-modal-detail">
                          <div class="table-responsive table-accordion">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th class="number">No</th>
                                  <th>Time (hour)</th>
                                  <th class="text-right">Charge (%)</th>
                                  <th class="text-center">Status</th>
                                  <th class="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in items" :key="item.id">
                                  <td class="text-center">{{ index + 1 }}</td>
                                  <td>{{ item.totalHourBeforePickup }}</td>
                                  <td class="text-right">{{ item.percentageCharge }}</td>
                                  <td class="text-center">
                                    <label class="cursor-pointer">
                                      <input
                                        type="checkbox"
                                        class="control-checkbox"
                                        v-model="item.isActive"
                                        :disabled="!isAllowToUpdate"
                                        @change="changeStatus(item)"
                                      />
                                      <span class="pl-5 font-weight-normal v-align-middle">
                                        {{ item.isActive ? "Active" : "Inactive" }}
                                      </span>
                                    </label>
                                  </td>
                                  <td class="text-center">
                                    <div class="button-action-wrapper">
                                      <button
                                        v-if="isAllowToUpdate"
                                        class="btn btn-default"
                                        type="button"
                                        @click="bindModel(item)"
                                      >
                                        <span>Edit</span>
                                      </button>
                                      <button
                                        v-if="isAllowToDelete"
                                        class="btn btn-default"
                                        type="button"
                                        @click="confirmDelete(item.id)"
                                      >
                                        <i class="ic-close"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!-- End: Table -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import buyingTariffCancellationSurchargeService from "@/services/master/buyingTariff/buyingTariffOverriddenCancellationSurchargeService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
  },
  data() {
    return {
      isSubmitted: false,
      isOpen: false,
      allPermissions: [],
      selectedPolicy: null,
      formatter: null,
      moneyFormat: null,
      itemToBeDeleted: null,
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        totalHourBeforePickup: { required, minValue: minValue(0) },
        percentageCharge: { required, minValue: minValue(0) },
      },
    };
  },
  created() {
    this.$eventBus.$on(
      "initializeBuyingTariffOverriddenCancellationSurcharge",
      this.initialize
    );
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeBuyingTariffOverriddenCancellationSurcharge");
  },
  methods: {
    async initialize(policy) {
      try {
        this.isLoading = true;
        this.isOpen = true;
        this.selectedPolicy = policy;
        this.moneyFormat = policy.moneyFormat;
        this.formatter = new Intl.NumberFormat(policy.moneyFormat.cultureCode, {
          style: "currency",
          currency: policy.moneyFormat.currencyCode,
          currencyDisplay: "code",
          minimumFractionDigits: policy.moneyFormat.numberOfDecimal,
        });
        this.reset();

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions =
          profile.services["BuyingTariffOverriddenCancellationSurcharge"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          await this.getAll();
        }

        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    openModal() {
      $(this.$refs.vuemodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    closeModal() {
      $(this.$refs.vuemodal).modal("hide");
      this.isOpen = false;
    },
    resetValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    bindModel(object) {
      this.isUpdate = true;
      this.resetValidation();
      this.model = Object.assign({}, object);
    },
    reset() {
      this.isUpdate = false;
      this.resetValidation();
      this.model = {};
    },
    async getAll() {
      this.items = await buyingTariffCancellationSurchargeService.getAll(
        this.selectedPolicy.policyId
      );
    },
    fixNumber() {
      this.model.totalHourBeforePickup = parseInt(this.model.totalHourBeforePickup);
      this.model.percentageCharge = parseFloat(this.model.percentageCharge);
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.policyId = this.selectedPolicy.policyId;
        this.fixNumber();
        if (!this.isUpdate) {
          await buyingTariffCancellationSurchargeService.create(this.model);
          this.$notification.success("Successfully added.", { title: "Success" });
        } else {
          await buyingTariffCancellationSurchargeService.update(this.model);
          this.$notification.success("Successfully updated.", { title: "Success" });
        }
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await buyingTariffCancellationSurchargeService.update(item);
        this.$notification.success("Successfully updated.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await buyingTariffCancellationSurchargeService.delete(this.itemToBeDeleted);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        this.isItemHasBeenModified = true;
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/buyingTariff/OverriddenCancellationSurcharge.vue